import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import moment from 'moment';
import { format, startOfMonth, set, isValid } from 'date-fns';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import SearchIcon from '@material-ui/icons/Search';
import DescriptionIcon from '@material-ui/icons/Description';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import Typography from '@material-ui/core/Typography';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Lock from '@material-ui/icons/Lock';
import SelectTable from '../../components/DataTable/SelectTable';
import { fetchEmployees } from '../../store/actions/employee';
import { requestTimeClockReport, requestImportAfd1510Report, requestImportAfd671Report,requestImportAEJReport } from '../../store/actions/report';
import { uploadAfdFileAFD1510, uploadAfdFileAFD671, uploadFingerPrint } from '../../store/actions/importEmployees';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import Input from '../../components/Input/Input';
import { FormControl, InputLabel, Select, Box } from '@material-ui/core';
import axiosInstance from '../../config/axiosInstance';

const styles = theme => ({
  container: {
    padding: `0 ${theme.spacing.unit * 3}px`,
  },
});

class ImportAfdReport extends React.Component {
  state = {
    withExtraHours: false,
    startDate: '',
    endDate: '',
    selected: [],
    searchQuery: '',
    anchorEl: null,
    AFD: '',
    lisEmployees: []
  };
  componentWillMount() {
    this.setState({
      startDate: startOfMonth(new Date()),
      endDate: set(new Date(), { hours: 23, minutes: 59, seconds: 59 }),
    });
    this.getListEmployees();
  }

  getListEmployees = async () => {
    const result = await axiosInstance.get('/employee/list')
    this.setState({ lisEmployees: result.data })
  }

  // componentDidMount() {
  //   this.props.onFetchEmployees();
  // }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };
  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  handleRequestAfd1510Report = () => {
    if (this.props.isExportAfd) {
      const {
        startDate, endDate, selected, withExtraHours,
      } = this.state;
      const report = {
        start: format(startDate, 'yyyy/MM/dd HH:mm'),
        end: format(endDate, 'yyyy/MM/dd HH:mm'),
        employees: selected,
        showCosts: withExtraHours,
      };
      this.props.onRequestAfd1510Report(report);
    } else {
      this.props.history.push('/assinatura')
    }
  };
  handleRequestAfd671Report = () => {
    if (this.props.isExportAfd) {
      const {
        startDate, endDate, selected, withExtraHours,
      } = this.state;
      const report = {
        start: format(startDate, 'yyyy/MM/dd HH:mm'),
        end: format(endDate, 'yyyy/MM/dd HH:mm'),
        employees: selected,
        showCosts: withExtraHours,
      };
      this.props.onRequestAfd671Report(report);
      this.handleClose();
    } else {
      this.props.history.push('/assinatura')
    }
  };

  handleRequestAEJReport = () => {
    if (this.props.isExportAfd) {
      const {
        startDate, endDate, selected, withExtraHours,
      } = this.state;
      const report = {
        start: format(startDate, 'yyyy/MM/dd HH:mm'),
        end: format(endDate, 'yyyy/MM/dd HH:mm'),
        employees: selected,
        // showCosts: withExtraHours,
      };
      this.props.onRequestAEJReport(report);
      this.handleClose();
    } else {
      this.props.history.push('/assinatura')
    }
  };

  handleInputChange = name => (event) => {
    if (event.target) {
      const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
      this.setState({ [name]: value });
    } else {
      this.setState({ [name]: event });
    }
  };
  handleSelectAll = (event, checked, searchSelect) => {
    const searchIndex = searchSelect.map(employee => employee.id);
    if (checked) {
      const newSelected = this.state.selected.slice();
      /* eslint-disable no-underscore-dangle */
      if (searchIndex) {
        if (this.state.selected.indexOf(searchIndex[0]) === -1) {
          this.state.lisEmployees.map(employee =>
          (searchIndex.indexOf(employee.id) > -1 &&
            newSelected.indexOf(employee.id) === -1 &&
            employee._workingDay !== null
            ? newSelected.push(employee.id)
            : null));
        } else {
          this.state.lisEmployees.map(employee =>
          (searchIndex.indexOf(employee.id) > -1 && employee._workingDay !== null
            ? newSelected.splice(newSelected.indexOf(employee.id), 1)
            : null));
        }
      }
      /* eslint-enable */
      this.setState({ selected: newSelected });
    } else if (searchIndex.length === this.state.lisEmployees.length) {
      this.setState({ selected: [] });
    } else {
      const newSelected = this.state.selected.slice();
      this.state.lisEmployees.map(employee =>
      (searchIndex.indexOf(employee.id) > -1 && employee._workingDay !== null
        ? newSelected.splice(newSelected.indexOf(employee.id), 1)
        : null));
      this.setState({ selected: newSelected });
    }
  };
  handleSelect = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    this.setState({ selected: newSelected });
  };
  handleChangeAFD = (event) => {
    if (event.target.value == 1510) {
      this.setState({ AFD: event.target.value })
      console.log(event.target.value)
    } else if (event.target.value == 671) {
      this.setState({ AFD: event.target.value })
      console.log(event.target.value)
    } else if (event.target.value == 1) {
      this.setState({ AFD: event.target.value })
      console.log(event.target.value)
    }
  };
  isSelected = id => this.state.selected.indexOf(id) !== -1;
  render() {
    const {
      classes, loading, onUploadAfdFileAFD1510, onUploadAfdFileAFD671, onUploadFingerPrint,
    } = this.props;
    const {
      startDate, endDate, selected, searchQuery, anchorEl, lisEmployees
    } = this.state;
    const columns = [
      { name: 'enrollment', label: 'Matrícula' },
      { name: 'name', label: 'Nome' },
      { name: '_office', label: 'Cargo' },
      { name: 'department', label: 'Departamento' },
      { name: '_workingDay', label: 'Escala' },
    ];
    const searchFields = ['enrollment', 'name', '_office', 'department', '_workingDay'];
    return (
      <React.Fragment>
        <ContentHeader
          title="Integração em AFD"
          subtitle="Importe ou exporte os pontos dos funcionários no formato da portaria 1510/2009 ou da 671/2021"
        >
          <div style={{ display: 'flex' }}>
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <InputLabel variant="contained" id="demo-simple-select-label">Importar AFD</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={this.state.AFD}
                  label="Age"
                  onChange={this.handleChangeAFD}
                >
                  <MenuItem value={1510}>
                    <label htmlFor="contained-button-file">
                      <Button component="span">
                        <React.Fragment>
                          {/* <DescriptionIcon /> */}
                          <input
                            className={classes.input}
                            id="contained-button-file"
                            multiple
                            type="file"
                            accept=".txt"
                            style={{ display: 'none' }}
                            onChange={(file) => {
                              if (file && file.target.files[0]) {
                                onUploadAfdFileAFD1510(file.target.files[0]);
                              }
                            }}
                          />
                          AFD 1510/2009
                        </React.Fragment>
                      </Button>
                    </label>
                  </MenuItem>
                  <MenuItem value={671}>
                    <label htmlFor="contained-button-file">
                      <Button component="span">
                        <React.Fragment>
                          {/* <DescriptionIcon /> */}
                          <input
                            className={classes.input}
                            id="contained-button-file"
                            multiple
                            type="file"
                            accept=".txt"
                            style={{ display: 'none' }}
                            onChange={(file) => {
                              if (file && file.target.files[0]) {
                                onUploadAfdFileAFD671(file.target.files[0]);
                              }
                            }}
                          />
                          AFD 671/2021
                        </React.Fragment>
                      </Button>
                    </label>
                  </MenuItem>
                  <MenuItem value={1}>
                    <label htmlFor="contained-button-file">
                      <Button component="span">
                        <React.Fragment>
                          {/* <DescriptionIcon /> */}
                          <input
                            className={classes.input}
                            id="contained-button-file"
                            multiple
                            type="file"
                            accept=".txt"
                            style={{ display: 'none' }}
                            onChange={(file) => {
                              if (file && file.target.files[0]) {
                                onUploadFingerPrint(file.target.files[0]);
                              }
                            }}
                          />
                          INTEGRAÇÃO CONTROL FINGERPRINT
                        </React.Fragment>
                      </Button>
                    </label>
                  </MenuItem>

                </Select>
              </FormControl>
            </Box>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleClick}
              disabled={loading || !(isValid(startDate) && isValid(endDate) && selected.length)}
              style={{ marginLeft: 20 }}
            >
              <DescriptionIcon />   Exportar pontos
            </Button>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this.handleClose}
            >
              <MenuItem
                style={{
                  minWidth: 120,
                  backgroundColor: this.props.isExportAfd ? 'white' : '#00000042',
                  justifyContent: 'space-between'
                }}
                onClick={this.handleRequestAfd1510Report}
              >
                AFD 1510/2009
                {!this.props.isExportAfd && <Lock />}
              </MenuItem>
              <MenuItem
                style={{
                  backgroundColor: this.props.isExportAfd ? 'white' : '#00000042',
                  justifyContent: 'space-between'
                }}
                onClick={this.handleRequestAfd671Report}
              >
                AFD 671/2021
                {!this.props.isExportAfd && <Lock />}
              </MenuItem>
              <MenuItem
                style={{
                  backgroundColor: this.props.isExportAfd ? 'white' : '#00000042',
                  justifyContent: 'space-between'
                }}
                onClick={this.handleRequestAEJReport}
              >
                GERAR AEJ
                {!this.props.isExportAfd && <Lock />}
              </MenuItem>
             
            </Menu>
          </div>
        </ContentHeader>
        <Paper>
          <Grid
            container
            justify="space-between"
            alignItems="baseline"
            className={classes.container}
          >
            <Grid item xs={12} md={5}>
              <TextField
                value={searchQuery}
                onChange={this.handleInputChange('searchQuery')}
                label=" "
                placeholder="Buscar"
                type="text"
                fullWidth
                margin="normal"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="disabled" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={6} container justify="space-around">
              <Input
                elementType="dateTimePicker"
                label="Início do período"
                margin="normal"
                value={startDate}
                onChange={this.handleInputChange('startDate')}
              />
              <Input
                elementType="dateTimePicker"
                minDate={startDate}
                label="Fim do período"
                margin="normal"
                value={endDate}
                onChange={this.handleInputChange('endDate')}
              />
            </Grid>
          </Grid>
          <SelectTable
            rows={lisEmployees}
            columns={columns}
            loading={loading}
            disableRow="_workingDay"
            searchFields={searchFields}
            onSelect={this.handleSelect}
            onSelectAll={this.handleSelectAll}
            onSearchSelect={this.handleSearchSelect}
            checkSelect={this.isSelected}
            numSelected={selected.length}
            searchQuery={searchQuery.toUpperCase()}
          />
        </Paper>
        <Typography color="textSecondary" style={{ marginTop: '10px' }}>
          *Não é possível gerar relatório de funcionários sem escala cadastrada
        </Typography>
      </React.Fragment >
    );
  }
}
const mapStateToProps = state => ({
  loading: state.general.loading,
  // employees: state.employee.employees,
  isExportAfd: state.auth.privileges && state.auth.privileges.isExportAfd,
});
const mapDispatchToProps = dispatch => ({
  // onFetchEmployees: () => dispatch(fetchEmployees()),
  onRequestReport: report => dispatch(requestTimeClockReport(report)),
  onRequestAfd1510Report: report => dispatch(requestImportAfd1510Report(report)),
  onRequestAfd671Report: report => dispatch(requestImportAfd671Report(report)),
  onRequestAEJReport: report => dispatch(requestImportAEJReport(report)),
  onUploadAfdFileAFD1510: file => dispatch(uploadAfdFileAFD1510(file)),
  onUploadAfdFileAFD671: file => dispatch(uploadAfdFileAFD671(file)),
  onUploadFingerPrint: file => dispatch(uploadFingerPrint(file)),
});
ImportAfdReport.propTypes = {
  classes: PropTypes.object.isRequired,
  onFetchEmployees: PropTypes.func.isRequired,
  onRequestReport: PropTypes.func.isRequired,
  // employees: PropTypes.array.isRequired,
  loading: PropTypes.bool,
};
ImportAfdReport.defaultProps = {
  loading: false,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(ImportAfdReport));

